import type { TypedMoney } from "@commercetools/platform-sdk";
import { useCtxFns } from "../../global/page-context";
import { FONTS, fontSize } from "../../styles/fonts";
import { AttributesTags } from "../../components/_shared-components/ui-elements/AttributesTags/AttributesTags";
import { css } from "@emotion/react";
export const ProductNameWithPrice: React.FC<{
  productName: string;
  price: TypedMoney | undefined;
  attributes: Array<string>;
}> = ({ productName, price, attributes }) => {
  const { showPrice } = useCtxFns();

  return (
    <>
      <span css={[fontSize.x2, FONTS.SwarovskiFutura500]}>
        <span className="_headline">{productName}</span>

        {attributes.length > 0 ? (
          <div
            css={css`
              margin-top: 4px;
            `}
          >
            <AttributesTags attributes={attributes} size="small" />
          </div>
        ) : null}
      </span>

      {price ? <span css={[fontSize.x2, FONTS.SwarovskiFutura300]}>{showPrice(price)}</span> : null}
    </>
  );
};
